import React, { useCallback, useEffect, useState } from 'react';
import { batch, useDispatch, useSelector } from 'react-redux';
import { Tappable } from '@vectord/components';

import { RESCHEDULE_REASON_MODAL_STAGES } from '@classCreation/data/rescheduleReasonModalStages';
import { rescheduleSbatGroupErrorsSelectors } from '@classCreation/selectors/rescheduleSbatGroup';
import {
  setRescheduleModalStage,
  setNewDateOfTopic,
  setSelectedRescheduleSbatGroup,
} from '@classCreation/store/rescheduleSbatGroup';
import FieldErrors from 'components/FieldErrors';
import Form from 'components/Form';
import SbatGroupInput from '../SbatGroupInput';
import styles from './EditSbatGroupForm.module.scss';

export default function EditSbatGroupForm({
  isEditing,
  setIsEditing,
  sbatGroup,
}) {
  const dispatch = useDispatch();
  const errors = useSelector(rescheduleSbatGroupErrorsSelectors);
  const [group, setGroup] = useState(sbatGroup);
  const { date_of_topic: newDateOfTopic } = group;

  useEffect(() => {
    if (!isEditing) {
      setGroup(sbatGroup);
    }
  }, [sbatGroup, isEditing]);

  const handleProceed = useCallback(
    (event) => {
      event.preventDefault();
      batch(() => {
        dispatch(setNewDateOfTopic(newDateOfTopic));
        dispatch(
          setRescheduleModalStage(RESCHEDULE_REASON_MODAL_STAGES.reason)
        );
        dispatch(setSelectedRescheduleSbatGroup(sbatGroup));
      });
    },
    [dispatch, newDateOfTopic, sbatGroup]
  );

  const handleTopicDateTimeChange = useCallback((newTopic) => {
    setGroup(newTopic);
  }, []);

  return (
    <Form
      onSubmit={handleProceed}
      className={styles.root}
    >
      <SbatGroupInput
        value={group}
        disabled={!isEditing}
        onChange={handleTopicDateTimeChange}
      />
      <FieldErrors
        errors={errors}
        name="base"
      />
      {isEditing && (
        <Tappable
          className="btn btn-primary btn-long m-t-xs"
          component="button"
          type="submit"
        >
          Save and Proceed
        </Tappable>
      )}
    </Form>
  );
}
